const REQUEST_TIMEOUT_MS = 10000;
function statusUrlFromToggleUrl(toggleUrl) {
    const stripped = toggleUrl.replace(/\/toggle\/?$/i, '');
    return stripped === toggleUrl ? null : stripped;
}
function parseBookmarkStateResponse(parsed, ok, status) {
    var _a;
    if (status === 401 || status === 403) {
        return { success: false, reason: 'unauthenticated' };
    }
    const envelope = parsed && typeof parsed === 'object' ? parsed : null;
    if (!ok || (envelope === null || envelope === void 0 ? void 0 : envelope.success) === false) {
        return { success: false, reason: 'server', code: (_a = envelope === null || envelope === void 0 ? void 0 : envelope.error) === null || _a === void 0 ? void 0 : _a.code };
    }
    if (typeof (envelope === null || envelope === void 0 ? void 0 : envelope.data) !== 'boolean') {
        return { success: false, reason: 'server' };
    }
    return { success: true, isBookmarked: envelope.data };
}
function resolveSameOrigin(url) {
    try {
        const resolved = new URL(url, window.location.origin);
        return resolved.origin === window.location.origin ? resolved : null;
    }
    catch (_a) {
        return null;
    }
}
async function send(method, rawUrl, signal) {
    const url = resolveSameOrigin(rawUrl);
    if (!url) {
        return { success: false, reason: 'invalid-url' };
    }
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
    const onExternalAbort = () => controller.abort();
    if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
        controller.abort();
    }
    else {
        signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', onExternalAbort);
    }
    try {
        const response = await fetch(url.toString(), {
            method,
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            signal: controller.signal,
        });
        const parsed = await response.json().catch(() => null);
        return parseBookmarkStateResponse(parsed, response.ok, response.status);
    }
    catch (_a) {
        return { success: false, reason: 'network' };
    }
    finally {
        clearTimeout(timer);
        signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', onExternalAbort);
    }
}
function getBookmarkStatus(statusUrl, signal) {
    return send('GET', statusUrl, signal);
}
/** The toggle is not idempotent on the server, so a failed POST is never retried. */
async function toggleBookmark(toggleUrl, intended, signal) {
    const result = await send('POST', toggleUrl, signal);
    if (result.success && result.isBookmarked !== intended) {
        return { success: false, reason: 'state-mismatch' };
    }
    return result;
}

export { getBookmarkStatus, parseBookmarkStateResponse, statusUrlFromToggleUrl, toggleBookmark };
